import { render, staticRenderFns } from "./CompanyEmployeeLeaveAssignmentPage.vue?vue&type=template&id=0b435eed&scoped=true&"
import script from "./CompanyEmployeeLeaveAssignmentPage.vue?vue&type=script&lang=js&"
export * from "./CompanyEmployeeLeaveAssignmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b435eed",
  null
  
)

export default component.exports